import { AUFTRAG_API } from '@Constants/backendConstants';
import { EnumProcessState } from '@Model';
import { EnumFilterExpressionOperation, EnumOperation, type ListRequest } from '@synqo/frontend-component-library';
import { useCallback } from 'react';
import { useListApi } from '@Hooks/useListApi';
import { OrdersRepository } from '@Repositories/Auftragsbearbeitung';

export function useGetOrders(processState?: EnumProcessState, withContainerActions = false) {
    const { loadPage: loadOrdersPage } = useListApi(OrdersRepository, AUFTRAG_API, [
        'Customer',
        'Site',
        'PickupSite',
        'Carrier',
        'DeliverySite',
        ...(withContainerActions ? ['ContainerActions'] : []),
    ]);

    const loadWithAdditionalFilters = useCallback(
        (lr: ListRequest) => {
            if (processState !== undefined) {
                if (lr.filter_columns === undefined) {
                    lr.filter_columns = { operation: EnumFilterExpressionOperation.And, filters: [] };
                }
                lr.filter_columns.filters.push({
                    field: 'process_state',
                    value: processState.toString(),
                    operator: EnumOperation.Equal,
                });
            }

            return loadOrdersPage(lr);
        },
        [loadOrdersPage, processState],
    );

    return loadWithAdditionalFilters;
}
